// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1FesU","label":"LabeledBox_label__221r-"};